import { Component, Input } from '@angular/core';
import { ComponentBase } from '../_component.base.js';
import {
	Breadcrumb,
	BreadcrumbsService,
} from '../../services/breadcrumbs/breadcrumbs.service.js';
import { DeploymentContext } from '../../utilities/deployment-context/deployment-context.js';

@Component({
	selector: 'breadcrumbs',
	templateUrl: './breadcrumbs.component.html',
	styleUrls: ['./breadcrumbs.component.scss'],
	standalone: false,
})
export class BreadcrumbsComponent extends ComponentBase {
	@Input()
	public separatorIconPath: string = '/assets/common/Path.svg';

	public constructor(
		dc: DeploymentContext,
		private _breadcrumbsService: BreadcrumbsService
	) {
		super(dc);
	}

	public get breadcrumbs(): Breadcrumb[] {
		// ADJQ-1071: The AKQA redesign provides an Explore navigation affordance separately, and removes
		// it from the breadcrumbs. The easiest thing for us to do is filter out the Explore (root) breadcrumb
		// visually, but leave it available for use by others. Its action, BreadcrumbsService, does a few
		// things for us that is nice to have centralized.
		return this._breadcrumbsService.breadcrumbs.filter(
			(bc) => bc !== this._breadcrumbsService.rootBreadcrumb
		);
	}

	public get isShowingBreadcrumbs(): boolean {
		return this._breadcrumbsService.breadcrumbs.length > 1;
	}

	public performBreadcrumbAction(breadcrumb: Breadcrumb): void {
		if (breadcrumb.action) {
			breadcrumb.action();
		}
	}
}
